import styled from "styled-components";

export const ContainerSlaughterSchedule = styled.div`
  table {
    border-collapse: collapse !important;
  }
  .colBordered {
    border: 1px solid #4b4b4b;
  }
`;
